import React from 'react'
import { connect } from 'react-redux'
import TopicHeader from '../components/TopicHeader'
import { toJS } from '../../../util/ToJS'
import { makeSelectTopic, SUBJECT_TOPICS } from '../../../redux/modules/topic'

class VisibleTopicHeader extends React.PureComponent {
  container = null;
  containerRect = null;
  fontSize = null;
  constructor(props) {
    super(props)
    this.state = {
      ticking: false,
      stickyHeaderEnabled: false
    }
    this.onScroll = this.onScroll.bind(this)
  }
  componentDidMount() {
    window.addEventListener('scroll', this.onScroll, false)
    this.containerRect = this.container.getBoundingClientRect()
    this.fontSize = parseInt(window.getComputedStyle(this.container).getPropertyValue('font-size').slice(0,-2))
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll, false)
  }

  onScroll() {
    if (!this.state.ticking) {
      window.requestAnimationFrame(() => {
        const stickyHeaderEnabled = window.scrollY > this.containerRect.bottom-this.fontSize*3
        this.setState({
          ticking: false,
          stickyHeaderEnabled
        })
      })
      this.setState({
        ticking: true
      })
    }
  }
  render() {
    const {
      stickyHeaderEnabled
    } = this.state
    return (
      <TopicHeader
        {...this.props}
        stickyHeaderEnabled={stickyHeaderEnabled}
        containerRef={node => this.container = node}
      />
    )
  }
}

const makeMapStateToProps = () => {
  const selectTopic = makeSelectTopic()
  const mapStateToProps = state => {
    const topic = selectTopic(state)
    return {
      id: topic.get('id'),
      title: topic.get('renderedTitle'),
      description: topic.get('renderedDescription'),
      breadcrumbTopics: topic.get('breadcrumbs'),
      scores: topic.get('scores'),
      slug: topic.get('slug'),
      isSubjectTopic: SUBJECT_TOPICS.has(topic.get('id')),
      practiceEnabled: topic.get('practiceEnabled')
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps)(toJS(VisibleTopicHeader))



// WEBPACK FOOTER //
// ./src/domains/topic/containers/VisibleTopicHeader.js